import { Text, makeStyles, tokens } from '@fluentui/react-components';
import { formatAmount } from '../utils/price';
import type { OrderQuote } from '../types/catering';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end',
    gap: tokens.spacingHorizontalS,
  },
  muted: {
    color: tokens.colorNeutralForeground3,
  },
});

export type CostBreakdownProps = {
  quote: OrderQuote;
};

export function CostBreakdown({ quote }: CostBreakdownProps) {
  const styles = useStyles();
  const totalDishes = quote.items.reduce((total, item) => total + item.portionsPerPerson, 0);

  return (
    <div className={styles.root} aria-label="Cost breakdown">
      <div className={styles.row}>
        <Text className={styles.muted}>
          {totalDishes} {totalDishes === 1 ? 'dish' : 'dishes'} · subtotal
        </Text>
        <Text>{formatAmount(quote.subtotal)}</Text>
      </div>
      <div className={styles.row}>
        <Text className={styles.muted}>Delivery &amp; setup</Text>
        <Text>{formatAmount(quote.deliveryAndSetup)}</Text>
      </div>
      <div className={styles.row}>
        <Text className={styles.muted}>VAT</Text>
        <Text>{formatAmount(quote.vat)}</Text>
      </div>
      <div className={styles.row}>
        <Text weight="semibold">Total cost</Text>
        <Text size={500} weight="semibold">
          {formatAmount(quote.total)} £
        </Text>
      </div>
    </div>
  );
}
